'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _linkWrapper = require('../../link-wrapper');

var _linkWrapper2 = _interopRequireDefault(_linkWrapper);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /** @jsx dom */


var getCrumb = function getCrumb(data, props) {
	return (0, _magicVirtualElement2.default)(
		'span',
		{ key: data.key, 'class': ['CMS-Breadcrumbs-item', props.styleClasses.Item], 'data-style-attr': 'Item' },
		data.delimiterBefore && (0, _magicVirtualElement2.default)(
			'span',
			{ 'class': ['CMS-Breadcrumbs-delimiter', props.styleClasses.Delimiter], 'data-style-attr': 'Delimiter' },
			props.delimiter
		),
		(0, _magicVirtualElement2.default)(
			_linkWrapper2.default,
			{ 'class': ['CMS-Breadcrumbs-link', props.styleClasses.Link], href: data.href, 'data-style-attr': 'Link' },
			data.name
		),
		data.delimiterAfter && (0, _magicVirtualElement2.default)(
			'span',
			{ 'class': ['CMS-Breadcrumbs-delimiter', props.styleClasses.Delimiter], 'data-style-attr': 'Delimiter' },
			props.delimiter
		)
	);
};

var getCrumbs = function getCrumbs(props) {
	var breadCrumbs = [].concat(_toConsumableArray(props.data));

	breadCrumbs.splice(0, props.startOnHierarchyLevel - 1);

	var items = breadCrumbs.map(function (crumb, i) {
		return getCrumb({
			delimiterAfter: i + 1 < breadCrumbs.length,
			href: '/' + crumb.linkFriendlyName,
			key: crumb.categoryId,
			name: crumb.categoryName
		}, props);
	});

	if (props.prependWithStartPage) {
		items.unshift(getCrumb({
			delimiterAfter: true,
			href: props.startPageURL.startsWith('/') ? props.startPageURL : '/' + props.startPageURL,
			key: props.startPageURL + '-' + props.startPageLabel,
			name: props.startPageLabel
		}, props));
	}

	if (props.article.art_id) {
		items.push(getCrumb({
			delimiterBefore: props.prependWithStartPage && items.length > 1 || !props.prependWithStartPage,
			href: '/' + props.articleUrlPrefix + '/' + props.article.link_friendly_name,
			key: 'article-' + props.article.art_id,
			name: props.article.artname
		}, props));
	}

	return items;
};

var afterMount = function afterMount(_ref) {
	var props = _ref.props;
	return !props.data && props.categoryId > 0 && props.fetch(props.categoryId);
};
var afterUpdate = function afterUpdate(_ref2) {
	var props = _ref2.props;
	return !props.data && props.categoryId > 0 && props.fetch(props.categoryId);
};

var render = function render(_ref3) {
	var props = _ref3.props;

	if (!props.data) {
		return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('noscript', null), props);
	}

	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)(
		'div',
		{ 'class': ['CMS-Breadcrumbs', props.styleClasses.Breadcrumbs], 'data-style-attr': 'Breadcrumbs' },
		getCrumbs(props)
	), props);
};

exports.default = { afterMount: afterMount, afterUpdate: afterUpdate, render: render };